module.exports = __webpack_public_path__ + "img/main.88d8caf3.jpg";